module.exports = __webpack_public_path__ + "img/healthcare.167139e5.svg";